import VEGA_SPECS from '../../public/spec/vega/index.json';
import VEGA_LITE_SPECS from '../../public/spec/vega-lite/index.json';

export {VEGA_SPECS, VEGA_LITE_SPECS};
